import {Box, Stack} from '@mui/material';
import {Drawer} from 'presentation/components/Drawer';
import {HandleMessage} from 'presentation/components/HandleMessage';
import {translations} from 'presentation/translations-new';
import {formatText} from 'presentation/utils/formatText';
import React from 'react';
import {BoxStyled, TypographyStyled} from './styles';
import {ExamAuthRequiredProps} from './types';

const {
	examAuthRequired: {title, descriptionPart1, descriptionPart2, actionLabel},
} = translations['pt-br'].privateFlow.bookingFlow.specialtyFlow;
const {close} = translations['pt-br'].commons;

export function ExamAuthRequiredDrawer({
	examSelected,
	handleNavigateToExamAuth,
	handleClose,
	open,
}: ExamAuthRequiredProps) {
	const examNameFormatted = formatText(examSelected);

	return (
		<Drawer.Root
			open={open}
			onOpen={() => {}}
			width="474px"
			customMaxHeight={'100%'}
			onClose={handleClose}
			sx={{zIndex: 9000}}>
			<Drawer.Header title={title} onClose={handleClose} />
			<Drawer.Content sx={{overflow: 'visible'}}>
				<Stack mt={1.5} gap={2}>
					<BoxStyled>
						<TypographyStyled variant="subtitle2">{examNameFormatted}</TypographyStyled>
					</BoxStyled>

					<Box>
						<HandleMessage message={descriptionPart1} variables={[examNameFormatted]} />
					</Box>

					<Box>
						<HandleMessage message={descriptionPart2} />
					</Box>
				</Stack>
			</Drawer.Content>
			<Drawer.Footer
				canStacks
				firstButtonTitle={close}
				firstButtonOnClick={handleClose}
				secondButtonTitle={actionLabel}
				secondButtonOnClick={handleNavigateToExamAuth}
			/>
		</Drawer.Root>
	);
}
